export const processCKEditorData = (data) => {
  let newData = data
  newData = newData.replaceAll('<table', '<div style="width: 100%; overflow-x: scroll"><table')
  newData = newData.replaceAll('</table>', '</table></div>')
  return newData
}
